import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Hdd = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M15.334 9.024H.667a.333.333 0 0 1 0-.667h14.667a.333.333 0 1 1 0 .667Z" />
      <path d="M4 3.023h8a.334.334 0 0 1 .283.157l3.333 5.333c.033.053.051.114.051.177v5.333a.333.333 0 0 1-.333.333H.667a.333.333 0 0 1-.333-.333V8.69c0-.063.018-.124.05-.177L3.719 3.18A.333.333 0 0 1 4 3.023Zm7.816.667h-7.63L1 8.786v4.904h14V8.786L11.815 3.69Z" />
      <path d="M12.666 11.69H3.333a.333.333 0 1 1 0-.667h9.333a.333.333 0 0 1 0 .667Z" />
    </svg>
  );
};

Hdd.category = 'product-category';

Hdd.displayName = 'Hdd';
